import { IconSearch } from '@/app/(webapp)/_components/ui/icons';
import { Input } from '@/app/(webapp)/_components/ui/input';
import { usePathname, useRouter } from '@/app/(webapp)/_i18n/navigation';
import { useSearchParams } from 'next/navigation';
import { ReactElement, useRef } from 'react';

interface SearchBarPros {
    title: string;
    className?: string;
    icon?: ReactElement;
    hasIcon?: boolean;
    onSearchDone?: () => void;
}

export default function SearchBar({ title, className, icon, hasIcon, onSearchDone }: SearchBarPros) {
    const HasIcon: boolean = hasIcon ?? true;
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const inputRef = useRef<HTMLInputElement>(null);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch?.((e.target as HTMLInputElement).value);
        }
    };

    const handleSearch = (searchTerm: string) => {
        const term = searchTerm.trim();
        if (!term) return;

        const isSearchPage = pathname === '/content-programs' || pathname === '/content-formats';

        if (isSearchPage) {
            const params = new URLSearchParams(searchParams.toString());
            params.set('q', term);

            router.push({
                pathname,
                query: Object.fromEntries(params.entries()),
            });
        } else {
            router.push({
                pathname: '/content-programs',
                query: { q: term },
            });
        }

        if (inputRef.current) inputRef.current.value = '';
        onSearchDone?.();
    };

    return (
        <div
            className={`
                flex p-[13px] ${className ? className : ''}
            `}
        >
            <div
                onClickCapture={() => {
                    if (inputRef.current) handleSearch(inputRef.current.value);
                }}
            >
                {HasIcon ? icon ? icon : <IconSearch /> : undefined}
            </div>
            <Input
                ref={inputRef}
                placeholder={title}
                className="border-0 p-0 px-[9px] h-[initial] focus-visible:border-none focus-visible:ring-0"
                onKeyDown={(e) => {
                    handleKeyDown(e);
                }}
            />
        </div>
    );
}
